import './styles/modal.scss';
import './styles/modal-theme.scss';
import './modal.js';
import './controllers/modalController.js';
import './directives/modalDirectives.js';
import './services/modalService.js';